<app-modal #modal>
  <h3 [translate]="title"></h3>

  <div class="mt-3">
    <p [translate]="message"></p>
  </div>

  <div class="py-3 flex justify-end">
    <Button (click)="close()" color="red" size="small" type="submit">{{ confirmButton | translate }}</Button>
  </div>
</app-modal>
